<i18n>
  {
    "pt_BR": {
      "empty": "Nenhuma mensagem registrada..."
    }
  }
</i18n>

<template>
  <section class="details">
    <article class="details-card">
      <Table
        csv
        route="sms"
        :columns="columns"
        :empty="$t('empty')"
        />
    </article>
  </section>
</template>

<script>
  import Table from './Table';

  const format = 'DD/MM/YY HH:mm';

  export default {
    components: {
      Table,
    },

    computed: {
      columns: () => ([
        {
          label: 'Data de Envio / Recebimento',
          field: 'created_at',
          type: 'date',
          dateInputFormat: format,
          dateOutputFormat: format,
        },
        {
          label: 'Nome',
          field: 'name',
        },
        {
          label: 'Telefone',
          field: 'to',
          sortable: false,
        },
        {
          label: 'Empresa',
          field: 'company',
        },
        {
          label: 'Campanha',
          field: 'campaign',
        },
        {
          label: 'Conteúdo da mensagem',
          field: 'body',
        },
        {
          label: 'Status',
          field: 'status_identifier',
        },
      ]),
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Campaign/Overview.vue